import React, { useState } from 'react';
import './EnlargableImage.css';

function EnlargeableImage({ images: rawImages, productName, isOutOfStock }) {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const images = Array.isArray(rawImages) && rawImages.length > 0
        ? rawImages
        : ['https://via.placeholder.com/600x400?text=Brak+zdjęcia'];

    const getImgSrc = (img) => {
        if (!img) return 'https://via.placeholder.com/300x200?text=Brak+zdjęcia';
        const rawPath = typeof img === 'object' ? (img.url || img.path) : img;
        if (!rawPath) return 'https://via.placeholder.com/300x200?text=Brak+zdjęcia';
        if (rawPath.startsWith('http') || rawPath.startsWith('data:')) return rawPath;
        const cleanPath = rawPath.startsWith('/') ? rawPath : `/${rawPath}`;
        return `${process.env.REACT_APP_API_URL}${cleanPath}`;
    };

    const handlePrev = () => {
        setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    const handleNext = () => {
        setCurrentImageIndex((prev) => (prev + 1) % images.length);
    };

    return (
        <div className="pp-gallery">
            <div className="pp-image-container">
                <img 
                    src={getImgSrc(images[currentImageIndex])} 
                    alt={productName} 
                    className={`pp-main-image ${isOutOfStock ? 'grayscale-img' : ''}`} 
                />
                {images.length > 1 && (
                    <>
                        <button className="pp-arrow pp-left" onClick={handlePrev}>&lt;</button>
                        <button className="pp-arrow pp-right" onClick={handleNext}>&gt;</button>
                    </>
                )}
            </div>
            {images.length > 1 && (
                <div className="pp-thumbnails">
                    {images.map((img, idx) => (
                        <img
                            key={idx}
                            src={getImgSrc(img)}
                            alt={`thumb-${idx}`}
                            className={`pp-thumbnail ${idx === currentImageIndex ? 'pp-active' : ''}`}
                            onClick={() => setCurrentImageIndex(idx)}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}

export default EnlargeableImage;